
import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Offers from './components/Offers';
import Delivery from './components/Delivery';
import Location from './components/Location';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#E63946]">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <Menu />
      <Offers />
      <Delivery />
      <Location />
      <Footer />
    </div>
  );
}
